import React from 'react';

import { FlexAlignValues, FlexDirectionValues, ToggleValues } from '@candu-ai/craft/layout';
import { ValueBox, ValueGroup } from '@candu-ai/craft/ui';
import { CommonNodeProperties } from 'craft/types';

import { AlignBaseline, AlignCenter, AlignFlexEnd, AlignFlexStart, AlignStretch } from './Toggles';

export interface ElementAlignmentProps {
  simpleMode?: boolean;
  toggleValues: ToggleValues;
  parentFlexDirection: FlexDirectionValues;
  alignSelf?: FlexAlignValues;
}

export const ElementAlignment = ({
  simpleMode,
  toggleValues,
  parentFlexDirection,
  alignSelf,
}: ElementAlignmentProps) => {
  if (parentFlexDirection === CommonNodeProperties.Multiple) {
    return null;
  }

  return (
    <ValueGroup data-cy="toolbox-element-alignment">
      <ValueBox data-cy="toolbox-flex-align-valuebox" label="Align">
        {!simpleMode && (
          <AlignStretch
            toggleValues={toggleValues}
            flexDirection={parentFlexDirection}
            alignSelf={alignSelf}
            isChild
          />
        )}
        <AlignFlexStart
          toggleValues={toggleValues}
          flexDirection={parentFlexDirection}
          alignSelf={alignSelf}
          isChild
        />
        <AlignCenter
          toggleValues={toggleValues}
          flexDirection={parentFlexDirection}
          alignSelf={alignSelf}
          isChild
        />
        <AlignFlexEnd
          toggleValues={toggleValues}
          flexDirection={parentFlexDirection}
          alignSelf={alignSelf}
          isChild
        />
        {!simpleMode && (
          <AlignBaseline
            toggleValues={toggleValues}
            flexDirection={parentFlexDirection}
            alignSelf={alignSelf}
            isChild
          />
        )}
      </ValueBox>
    </ValueGroup>
  );
};
